import { AsOrganization } from "@baseTypes/service/ICompanyService";
import { ServerResponse, ServerResponseN } from "@baseTypes/baseType";
import xhr from "@infobis/api-module";

export type AsClientNode = {
    clientId: number
    data: AsClientNode[]
    expanded: boolean
    glid: number
    leaf: boolean
    name: string
    timeZoneId: string
}

export default class OrganizationService {

    static fetchTree = (): Promise<ServerResponseN<AsClientNode>> => {
        const request = {
            url: `/clientsTree`,
            params: {
                method: 'GET',
            },
            authorize: true
        };

        return xhr.req(request);
    }
    static fetch = (): Promise<ServerResponse<AsOrganization[]>> => {
        const request = {
            url: `/companies`,
            params: {
                method: 'GET',
            },
            authorize: true
        };

        return xhr.req(request);
    }

    static authenticateOrganization = (company: any): Promise<ServerResponse<any>> => {
        const request = {
            url: '/setSelectedCompany',
            params: {
                method: 'POST',
            },
            body: JSON.stringify(company),
            authorize: true
        };

        return xhr.req(request);
    }
}